import { serverGet, serverPost } from "lib/serverRequest";

export const getUsers = ({ data = {}, onFinish = () => {} }) => {
  serverPost({ url: `users`, data, onFinish: onFinish });
};

export const getOneUser = ({ userid = "", onFinish = () => {} }) => {
  serverGet({ url: `user/${userid}`, onFinish: onFinish });
};

export const getCustomerLogs = ({
  url = "",
  data = {},
  onFinish = () => {},
}) => {
  serverPost({ url: `user/logs`, data: data, onFinish: onFinish });
};

export const createUser = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `register`,
    data: {
      name: data?.name ?? "",
      email: data?.email ?? "",
      phone: data?.phone ?? "",
      password: data?.password ?? "",
      role: data?.role ?? "0",
      card_name: data?.card_name ?? "",
      card_number: data?.card_number ?? "",
      card_expire: data?.card_expire ?? null,
      card_cvv: data?.card_cvv ?? "",
      address: data?.address ?? {},
    },
    onFinish: onFinish,
  });
};

export const updateUser = ({
  data = {},
  logData = {},
  onFinish = () => {},
}) => {
  serverPost({
    url: `user/update`,
    data: {
      id: data?.id,
      name: data?.name ?? "",
      email: data?.email ?? "",
      phone: data?.phone ?? "",
      phone_code: data?.phone_code ?? "64",
      status: data?.status?.id ?? "0",
      role: data?.role ?? "0",
      address: data?.address ?? {},
      ...logData,
    },
    onFinish: onFinish,
  });
};

export const checkUserLog = ({
  changerName = "",
  newValue = {},
  initial = {},
}) => {
  let log = "";
  const diffKeys = ["name", "phone", "user_status"].reduce((ret, key) => {
    return (newValue?.[key] ?? "") !== (initial?.[key] ?? "")
      ? [...ret, key]
      : ret;
  }, []);
  if (diffKeys?.length > 0) {
    let changeKeys = "";
    let changeValues = "";
    diffKeys.forEach((item, index) => {
      const key = item === "user_status" ? "status" : item;
      const value =
        key === "status" ? newValue?.[key]?.label ?? "" : newValue?.[key];
      changeKeys += index === diffKeys?.length - 1 ? key : `${key}, `;
      changeValues += index === diffKeys?.length - 1 ? value : `${value}, `;
    });
    log = `${changerName} ( admin ) - Acccount #${newValue?.id} - Update User's ${changeKeys} - ${changeValues}`;
  }
  return log;
};
